import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastrService: ToastrService) {}

  success(message: string, title: string = 'Success') {
    return this.toastrService.success(message, title, {
      timeOut: 3000,
      closeButton: true,
    });
  }

  info(message: string, title: string = 'Info') {
    return this.toastrService.info(message, title, {
      timeOut: 3000,
      closeButton: true,
    });
  }

  warning(message: string, title: string = 'Warning') {
    return this.toastrService.warning(message, title, {
      timeOut: 5000,
      closeButton: true,
    });
  }

  error(message: string, title: string = 'Error') {
    return this.toastrService.error(message, title, {
      timeOut: 8000,
      closeButton: true,
    });
  }
}
